export default "__VITE_ASSET__BO4396hs__"